import UpdateUserConfigurationJsonResponse from 'owa-service/lib/contract/UpdateUserConfigurationJsonResponse';
import UserConfigurationDictionaryObjectType from 'owa-service/lib/contract/UserConfigurationDictionaryObjectType';
import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import updateUserConfigurationService from 'owa-session-store/lib/services/updateUserConfiguration';

export interface UserConfigurationSetting {
    propertyName: string;
    propertyType: UserConfigurationDictionaryObjectType;
    /**
     * Any non-string value must be serialized to a string, per the service contract
     */
    propertyValue: string | string[];
}

export default function updateUserConfiguration(
    settingUpdates: UserConfigurationSetting[],
    configurationName: string = 'OWA.UserOptions'
): Promise<UpdateUserConfigurationJsonResponse> {
    return updateUserConfigurationService(
        configurationName,
        settingUpdates.map(update =>
            userConfigurationDictionaryEntry({
                DictionaryKey: userConfigurationDictionaryObject({
                    Type: 'String',
                    Value: [update.propertyName],
                }),
                DictionaryValue: userConfigurationDictionaryObject({
                    Type: update.propertyType,
                    Value: Array.isArray(update.propertyValue)
                        ? update.propertyValue
                        : [update.propertyValue],
                }),
            })
        )
    );
}
